(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
function memorialmenteArticleContents(root) {
  root.querySelectorAll('.ml-article__contents').forEach(nav => {
    if (nav.dataset.ready) return;
    const content = nav.closest('.article-template__content');
    const headings = Array.from(content.querySelectorAll('h2'));
    if (headings.length < 2) return;
    const list = nav.querySelector('ol');
    headings.forEach((heading,index) => {
      if (!heading.id) heading.id = 'ml-article-heading-' + index;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });
    nav.dataset.ready = 'true';
    nav.hidden = false;
  });
}
memorialmenteArticleContents(document);
document.addEventListener('shopify:section:load', event => memorialmenteArticleContents(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('memorialmente-slideshow')) {
    customElements.define('memorialmente-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = Array.from(this.querySelectorAll('.mm-hero__slide'));
        if (!this.slides.length) return;
        this.dots = Array.from(this.querySelectorAll('[data-index]'));
        this.rotation = this.querySelector('[data-action="rotation"]');
        this.announcement = this.querySelector('[data-announcement]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.current = 0;
        this.hovered = false;
        this.visible = false;
        this.editor = this.dataset.editor === 'true';
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || this.editor;
        this.interval = Math.max(2000, Number(this.dataset.interval) || 7000);
        this.addEventListener('pointerdown', (event) => {
          this.rotationBeforeFocus = event.target.closest('[data-action="rotation"]') ? this.paused : null;
        }, { signal });
        this.addEventListener('pointercancel', () => { this.rotationBeforeFocus = null; }, { signal });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.dataset.action === 'rotation') {
            const previous = this.rotationBeforeFocus;
            this.rotationBeforeFocus = null;
            this.paused = !(typeof previous === 'boolean' ? previous : this.paused);
            this.syncRotation();
            this.schedule();
          } else if (button.dataset.action === 'prev') this.move(this.current - 1, true);
          else if (button.dataset.action === 'next') this.move(this.current + 1, true);
          else if (button.hasAttribute('data-index')) this.move(Number(button.dataset.index), true);
        }, { signal });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, { signal });
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => { this.pause(); }, { signal });
        this.addEventListener('keydown', (event) => {
          if (event.target.closest('input, textarea, select, [contenteditable]')) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (this.slides.length < 2) return;
          event.preventDefault();
          const oldSlide = this.slides[this.current];
          const focusWasInSlide = oldSlide.contains(document.activeElement);
          this.move(this.current + (event.key === 'ArrowRight' ? 1 : -1), true);
          if (focusWasInSlide) this.querySelector('[data-action="' + (event.key === 'ArrowRight' ? 'next' : 'prev') + '"]').focus();
        }, { signal });
        this.addEventListener('touchstart', (event) => {
          this.touch = null;
          if (event.touches.length !== 1 || event.target.closest('a, button')) return;
          this.touch = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }, { signal, passive: true });
        this.addEventListener('touchend', (event) => {
          if (!this.touch || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.move(this.current + (dx < 0 ? 1 : -1), true);
        }, { signal, passive: true });
        this.addEventListener('touchcancel', () => { this.touch = null; }, { signal, passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.move(index, true);
        }, { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.pause(); }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0 });
        this.observer.observe(this);
        this.classList.add('is-ready');
        this.move(0);
      }
      pause() {
        this.paused = true;
        this.syncRotation();
        this.schedule();
      }
      move(index, manual = false) {
        this.current = (index + this.slides.length) % this.slides.length;
        if (manual) this.paused = true;
        this.slides.forEach((slide, i) => {
          const active = i === this.current;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, i) => {
          if (i === this.current) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const count = this.querySelector('[data-current]');
        if (count) count.textContent = String(this.current + 1).padStart(2, '0');
        if (manual && this.announcement) this.announcement.textContent = this.slides[this.current].getAttribute('aria-label');
        this.syncRotation();
        this.schedule();
      }
      syncRotation() {
        if (!this.rotation) return;
        this.rotation.setAttribute('aria-label', this.paused ? this.rotation.dataset.play : this.rotation.dataset.pause);
        this.rotation.querySelector('[data-rotation-icon]').textContent = this.paused ? '▶' : 'Ⅱ';
      }
      schedule() {
        clearTimeout(this.timer);
        this.timer = null;
        if (this.paused || this.hovered || !this.visible || document.hidden || this.editor || this.slides.length < 2) return;
        this.timer = setTimeout(() => this.move(this.current + 1), this.interval);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
